import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  evaluationMonitorsLength: 0,
  evaluationMonitors: [],
  evaluationMonitor: {},
  evaluationMonitorError: "",
  formError: "",
  loadingQuestionFactor: false,
  loadingQuestionCompentey: false,
  questionFactor: null,
  questionCompetency: null,
  questionFactorError: null,
  questionCompetencyError: null,
};

export default function EvaluationMonitorReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_EVALUATION_MONITOR:
      return { ...state, loading: action.payload };
    case actions.LOADING_EVALUATION_MONITOR_BY_ID:
      return { ...state, loadingById: action.payload };
    case actions.LOADING_QUESTION_FACTOR:
      return { ...state, loadingQuestionFactor: action.payload };
    case actions.LOADING_QUESTION_COMPETENCY:
      return { ...state, loadingQuestionCompentey: action.payload };
    case actions.SAVE_LOADING_EVALUATION_MONITOR:
      return { ...state, saveLoading: action.payload };
    case actions.GET_EVALUATION_MONITOR:
      return {
        ...state,
        evaluationMonitors: action.payload.evaluationMonitors,
        evaluationMonitorsLength: action.payload.evaluationMonitorsLength,
      };
    case actions.GET_EVALUATION_MONITOR_BY_ID:
      return {
        ...state,
        evaluationMonitor: action.payload,
      };

    case actions.GET_QUESTION_FACTOR:
      return { ...state, questionFactor: action.payload };
    case actions.GET_QUESTION_COMPETENCY:
      return { ...state, questionCompetency: action.payload };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.EVALUATION_MONITOR_FAIL:
      return { ...state, evaluationMonitorError: action.payload };
    case actions.QUESTION_FACTOR_FAIL:
      return { ...state, questionFactorError: action.payload };
    case actions.QUESTION_COMPETENCY_FAIL:
      return { ...state, questionCompetencyError: action.payload };
    default:
      return state;
  }
}
